<template>
	<div class="camera" ref="camera">
		<button @click="stopAndClose" class="close"><span class="visually-hidden">Close</span></button>
		<div class="video-wrapper">
			<video ref="video" autoplay playsinline></video>
		</div>
		<canvas ref="canvas" style="display: none;"></canvas>
		<div class="takephoto-wrapper">
			<button @click="takePhoto" class="takephoto"><span class="visually-hidden">Capture Photo</span></button>
			<button @click="toggleFacingMode" class="toggleface"><span class="visually-hidden">Toggle mode</span></button>
		</div>
		<div v-if="photo" class="photo-result">
			<div class="image-wrapper">
				<img :src="photo" alt="photo" />
			</div>
			<div class="buttons-wrapper">
				<p>{{ t('txt_photo_done', {sparks: sparks}) }}</p>
				<div class="buttons-column">
					<button @click="uploadPhoto" ref="upload" class="green upload">{{ t('txt_upload_photo') }}</button>
					<button @click="startCamera" ref="" class="green transparent qr">{{ t('txt_take_another_photo') }}</button>
				</div>
			</div>
		</div>
	</div>
	<div v-if="state.show" class="fullscreen-popup">
		<button @click="closePopup" class="close"><span class="visually-hidden">Close</span></button>
		<div class="popup-content">
			<img src="../assets/img/bulevar-small.svg" alt="Bulevar Logo" />
			<h1>{{ state.title }}</h1>
			<div v-html="state.description" class="description"></div>
			<div v-if="award" class="award-data">
				<div class="info">
					<h2>{{ award.title }}</h2>
					<div class="location">{{ t('txt_at') }} <router-link :to="`/providers/map/${award.partner_id}`" v-html="award.partner_title"></router-link></div>
				</div>
				<div class="until">{{ t('txt_until') }} {{ formatDate(award.valid_until, 'L') }}</div>
			</div>
			<div v-if="award" class="award-action">
				<div class="toprofile">
					<router-link :to="{ path: `/profile` }" class="">
						{{ t('txt_check_awards') }}
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import apiClient from '@/utils/axios';
import dayjs from '@/utils/dayjs';
export default {
	props: {
		sparks: {
			type: Number,
			required: true
		},
		id: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			photo: null,
			videoStream: null,
			facingMode: "user",
			award: false,
			state: {
				show: false
			}
		};
	},
	mounted() {
		//this.startCamera();
	},
	methods: {
		openPopup() {
			this.state.title = (this.award != false) ? this.t('txt_point_done_reward', {'sparks':this.sparks}) : this.t('txt_point_done', {'sparks':this.sparks});
			this.state.description = '';
			this.state.show = true;
		},
		closePopup() {
			this.stopCamera();
			this.$refs.camera.classList.remove('visible');
			window.location.reload();
		},
		stopAndClose() {
			this.stopCamera();
			this.$refs.camera.classList.remove('visible');
		},
		async startCamera() {
			try {
				this.photo = null;
				this.$refs.camera.classList.add('visible');
				if (this.videoStream) {
					this.videoStream.getTracks().forEach(track => track.stop());
				}
				this.videoStream = await navigator.mediaDevices.getUserMedia({
					audio: false,
					video: { 
						facingMode: this.facingMode,
						width: { ideal: 1080 },
						height: { ideal: 1080 }
					}
				});
				this.$refs.video.srcObject = this.videoStream;
			} catch (error) {
				console.error("Camera access denied or not supported", error);
			}
		},
		takePhoto() {
			const video = this.$refs.video;
			const canvas = this.$refs.canvas;
			const context = canvas.getContext("2d");
			const size = Math.min(video.videoWidth, video.videoHeight);
			canvas.width = size;
			canvas.height = size;
			context.drawImage(
				video,
				(video.videoWidth - size) / 2,
				(video.videoHeight - size) / 2,
				size,
				size,
				0,
				0,
				size,
				size
			);
			this.photo = canvas.toDataURL("image/jpg");
		},
		toggleFacingMode() {
			this.facingMode = this.facingMode === "user" ? "environment" : "user";
			if(this.facingMode == "user"){
				document.querySelector('video').style.transform = 'scaleX(-1)';
			} else {
				document.querySelector('video').style.transform = '';
			}
			this.startCamera();
		},
		stopCamera() {
			if (this.videoStream) {
				this.videoStream.getTracks().forEach((track) => track.stop());
			}
		},
		async uploadPhoto() {
			if (!this.photo) {
				alert("No photo to upload!");
				return;
			}

			try {
				this.$refs.upload.classList.toggle("uploading");
				this.$refs.upload.setAttribute('disabled',true);
				const formData = new FormData();
				const blob = this.dataURLtoBlob(this.photo);
				formData.append("file", blob, "photo.jpg");

				const response = await apiClient.post('/'+localStorage.getItem('lang')+'/api/upload/'+this.id, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				});
				if(response.data.award){
					this.award = response.data.award;
				}
				this.stopCamera();
				this.openPopup();
				this.$refs.upload.classList.toggle("uploading");
				this.$refs.upload.setAttribute('disabled',false);
			} catch (error) {
				console.error("Upload failed:", error);
				this.$refs.upload.classList.toggle("uploading");
				this.$refs.upload.setAttribute('disabled',false);
			}
		},
		dataURLtoBlob(dataURL) {
			const byteString = atob(dataURL.split(",")[1]);
			const mimeString = dataURL.split(",")[0].split(":")[1].split(";")[0];

			const byteArray = new Uint8Array(byteString.length);
			for (let i = 0; i < byteString.length; i++) {
				byteArray[i] = byteString.charCodeAt(i);
			}

			return new Blob([byteArray], { type: mimeString });
		},
		formatDate(date, format='L LT') {
			return dayjs(date).locale(localStorage.getItem('lang')).format(format);
		},
	},
	beforeUnmount() {
		this.stopCamera();
	},
	setup() {
		const { t } = useI18n();
		return {
			t
		};
	}
};
</script>

<style scoped>
	
</style>
